(function($){
  'use strict';
  var map = $('.map'),
      countries = map.find('.country');
  countries.each(function(){
    var image = $('#'+ this.id + '-flag image'),
        size = this.getBBox(),
        title = $(this).find('text.country-title');
    title.show();

    image.attr('height', size.height);
    if(typeof InstallTrigger !== 'undefined' || !('getElementsByClassName' in this)) {
      image.attr('width', size.width);
    } else {
      image.attr('x',(size.width - map.width()) / 2);
    }
  })
})(jQuery);